import { combineReducers } from 'redux';

import byId from './byId/reducer';
import ids from './ids/reducer';

export default combineReducers({
  byId,
  ids
});




/** WEBPACK FOOTER **
 ** ./src/members/state/user/avatars/reducer.js
 **/